module.exports = __webpack_public_path__ + "media/photography/photographyFullService-c665ce63.png";